/* Cupra AI Academy — theme behaviour */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* Sticky header solidifies once the page scrolls past the hero lip. */
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var threshold = 24;
    var ticking = false;

    var update = function () {
      header.classList.toggle('is-stuck', window.scrollY > threshold);
      ticking = false;
    };

    update();
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* Mobile navigation */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-nav-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* FAQ: only one answer open at a time within a group. */
  document.querySelectorAll('[data-accordion]').forEach(function (group) {
    var items = group.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  /* Cart line quantity inputs submit on change. */
  document.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
